import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, FileText, Mail, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
    {/* Hero */}
    <section className="bg-gradient-to-br from-[#0b1220] via-[#1a2744] to-[#0b1220] py-20">
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/15 text-accent text-xs font-semibold mb-4">
          <Shield className="w-3.5 h-3.5" /> CUMPLIMIENTO LEGAL
        </div>
        <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white mb-4">
          Política de Tratamiento de Datos Personales
        </h1>
        <p className="text-base text-white/80 max-w-2xl mx-auto">
          IAASP Latinoamérica — En cumplimiento de la Ley 1581 de 2012 y sus decretos reglamentarios.
        </p>
      </div>
    </section>

    {/* Content */}
    <article className="max-w-3xl mx-auto px-6 md:px-12 py-16">
      <Link to="/" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-primary mb-8">
        <ArrowLeft className="w-4 h-4" /> Volver al inicio
      </Link>

      <div className="prose-article space-y-6 text-base leading-relaxed text-foreground/90">
        <p>
          En cumplimiento de la <strong>Ley 1581 de 2012</strong> y sus decretos reglamentarios,
          <strong> IAASP Latinoamérica</strong> informa que los datos personales recolectados a través
          de sus canales físicos y digitales serán utilizados únicamente para fines{' '}
          <strong>académicos, administrativos y comerciales</strong> relacionados con sus programas de
          formación en seguridad y protección ejecutiva.
        </p>

        <section className="bg-secondary rounded-2xl p-6 border-l-4 border-accent">
          <h2 className="text-lg font-heading font-bold text-primary mb-3 flex items-center gap-2">
            <FileText className="w-5 h-5 text-accent" /> Finalidad del tratamiento
          </h2>
          <p className="mb-3">Los datos podrán ser utilizados para:</p>
          <ul className="list-disc pl-6 space-y-1.5 text-sm">
            <li>Gestión de inscripciones a programas y cursos.</li>
            <li>Contacto con estudiantes y egresados.</li>
            <li>Envío de información institucional.</li>
            <li>Emisión de certificados.</li>
            <li>Cumplimiento de obligaciones legales.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-heading font-bold text-primary mb-3">
            Protección y confidencialidad
          </h2>
          <p>
            IAASP Latinoamérica garantiza la <strong>protección, confidencialidad y seguridad</strong> de
            la información, implementando medidas adecuadas para evitar el acceso no autorizado, pérdida
            o uso indebido de los datos.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-heading font-bold text-primary mb-3">
            Derechos del titular
          </h2>
          <p>El titular de la información tiene derecho a:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2 text-sm">
            <li><strong>Conocer</strong> los datos personales que reposan en nuestras bases de datos.</li>
            <li><strong>Actualizar y rectificar</strong> sus datos personales.</li>
            <li><strong>Solicitar la supresión</strong> de sus datos personales.</li>
            <li><strong>Revocar la autorización</strong> previamente otorgada para el tratamiento.</li>
            <li>
              Presentar quejas ante la <strong>Superintendencia de Industria y Comercio</strong> de Colombia.
            </li>
          </ul>
        </section>

        <section className="bg-gradient-to-br from-primary to-[#1a2744] rounded-2xl p-6 text-white">
          <h2 className="text-lg font-heading font-bold mb-2 flex items-center gap-2">
            <Mail className="w-5 h-5 text-accent" /> Ejercicio de derechos
          </h2>
          <p className="text-sm text-white/85 mb-4">
            Para ejercer sus derechos, el titular podrá comunicarse a través de los canales oficiales
            de la organización.
          </p>
          <Link to="/contact">
            <Button size="sm" className="bg-accent hover:bg-accent/90 text-[#0b1220] font-semibold">
              Contactar a IAASP
            </Button>
          </Link>
        </section>

        <p className="text-xs text-muted-foreground pt-6 border-t">
          Última actualización: {new Date().toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>
    </article>
  </div>
);

export default PrivacyPolicy;
